export enum AnalyticsDashboardType {
    Engagement = "engagementanalytics",
    Prospects = "prospectanalytics",
    AmboStudent = "studentamboanalytics",
    AmboStaff = "staffamboanalytics",
    ProspectInsights = "prospectinsightsanalytics",
    ConversationInsights = "conversationinsightsanalytics",
}

export enum CustomerTier {
    PremiumPlusCustomer = "premiumplus",
    LiteAndProCustomer = "liteandpro",
}

export const LOGO_SERVICE_TRACKING = "logotracking";
export const LOGO_SERVICE_TRACKING_ENABLED_DASHBOARDS = new Set([AnalyticsDashboardType.Engagement]);

export const AnalyticsDashboardId = {
    unistaffamboanalyticspremiumplus: "22fd700f-e787-4697-aa50-b58e4a42beda",
    unistaffamboanalyticsliteandpro: "9fbd18d5-ce27-42b6-8abd-23f79b06e36d",
    uniengagementanalyticspremiumplus: "eedc1763-27ef-4d91-be52-8077fe1b872c",
    uniengagementanalyticsliteandpro: "a45b464a-c140-4498-8691-f21e4f56e168",
    uniengagementanalyticspremiumpluslogotracking: "a178d1da-ac52-4acb-b182-ce07a2a2d7c3",
    uniengagementanalyticsliteandprologotracking: "585c25e4-2e78-40e5-9d42-07fd602c6e01",
    uniprospectanalyticspremiumplus: "923d340f-a29f-4e53-80be-b2eacebe7fdb",
    uniprospectanalyticsliteandpro: "8efac665-3bd1-4f5a-b3c8-ec10b5c5872b",
    unistudentamboanalyticspremiumplus: "93e5f05d-a583-40f2-b01d-d4150d0aad8a",
    unistudentamboanalyticsliteandpro: "17dee2dc-5530-407a-a78a-5291a668c820",
    uniprospectinsightsanalyticspremiumplus: "303b4aaa-8880-4661-a2b2-ae237020c30f",
    uniprospectinsightsanalyticsliteandpro: "2af96274-1832-44cf-94d7-b49d81579195",
};
